import React from 'react'

import {
  IconRefresh,
  IllustrationErrorExplodingBalloon,
  IllustrationErrorUFO,
  IllustrationSecurity,
} from '@klarna/bubble-ui'

export const codes = {
  internal_server_error: {
    errorCode: '500',
    illustration: <IllustrationErrorUFO/>,
    title: 'Oops, something went wrong',
    message: 'For some reason on our side, we weren\'t able to run you request. You can try again or come back later.',
    hasGoBack: true,
    actionButton: {
      onClick: () => window.location.replace(location.pathname),
      icon: IconRefresh,
      label: 'Refresh',
    },
  },
  not_found: {
    errorCode: '404',
    illustration: <IllustrationErrorExplodingBalloon/>,
    title: 'There is nothing here!',
    message: 'This page doesn\'t exist or you typed a wrong address on your browser. Check the address and try again.',
    hasGoBack: true,
  },
  forbidden: {
    errorCode: '403',
    illustration: <IllustrationSecurity/>,
    title: 'You don\'t have access to this page',
    message: 'Your Merchant ID does not have access to this page. If you believe it is an error, please reach Merchant Support or contact the administrator of your company\'s account.',
    hasGoBack: true,
  },
  temporarily_unavailable: {
    errorCode: '503',
    illustration: <IllustrationErrorUFO/>,
    title: 'We\'re temporarily unavailable',
    message: 'We are currently undergoing maintenance and this service is down, we expect to resume back to normal in a while.',
    hasGoBack: true,
  },
  bad_request: {
    errorCode: '400',
    illustration: <IllustrationErrorExplodingBalloon/>,
    title: 'Oops, something went wrong',
    message: 'Plase try to refresh this page, use a different browser, clear your cache, restarting your computer or check your security updates. If the error persists, please reach support.',
    hasGoBack: true,
  },
}
